export enum TargetPlatformsTypes {
    DSP = 1,
    TV = 2,
    Other = 3
}